import { queryOptions } from '@tanstack/react-query';

import { getFeedbackCount } from './get-feedback-count';

export const feedbackQueryKeys = {
  all: ['feedback'] as const,
  counts: () => [...feedbackQueryKeys.all, 'count'] as const,
  count: (filter: StructuredFilter) =>
    [...feedbackQueryKeys.counts(), filter] as const,
};

// React Query가 filter 객체를 자동으로 직렬화하여 queryKey로 사용
export const feedbackCountQueryOptions = (
  filter: StructuredFilter,
  options?: { enabled?: boolean; staleTime?: number },
) => {
  return queryOptions({
    queryKey: feedbackQueryKeys.count(filter),
    queryFn: () => getFeedbackCount({ filter }),
    ...options,
  });
};
